import { Dropdown } from "primereact/dropdown"
import CommanDialog from "../CommonCompo/CommanDialog/CommanDialog"
import { MultiSelect } from "primereact/multiselect"
import { useCabinBookingForm } from "../../Hooks/Features/CabinBooking/useCabinBookingForm"
import _ from "underscore";
import PanelHeaderTemplate from "../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CabinBookingForm = ({ shiftTime, selectedCabin, selectedDate, closePopup, callApi, displaySlot, editData, gridData }) => {

    const { options, bookingValues, setBookingValues, timeSlots, handleSaveBooking, loader, handleTimeSlotSelection, showCancelBooking, handleDeleteBooking, showConfirmation, setShowConfirmation } = useCabinBookingForm({ shiftTime, selectedCabin, selectedDate, closePopup, callApi, displaySlot, editData, gridData });

    return (
        <div>
            <div>
                <div className="fw-bold">Select Duration*</div>
                <Dropdown className="input-dd" options={options?.duration} value={bookingValues?.duration} onChange={(e) => setBookingValues((prev) => ({ ...prev, duration: e.target.value }))} />
            </div>
            <div className="mt-2 mb-2">
                <div className="mb-1 fw-bold d-flex justify-content-between align-items-center">
                    <div>Available Time Slots*</div>
                    {(!editData || _.isEmpty(editData)) &&
                        <div className="c-pointer" onClick={() => setBookingValues((prev) => ({...prev, slot: []}))}><FontAwesomeIcon icon="fa-solid fa-close"/> Clear</div>
                    }
                </div>
                <div className="d-flex gap-2 flex-wrap" style={{ maxHeight: "30vh", overflowY: "auto" }}>
                    {timeSlots?.length > 0 ?
                        timeSlots?.map((time, index) => (
                            <div key={index} className={`px-2 py-1 w15 border rounded text-center cabin-time-slot ${!time?.disable && "c-pointer"} ${_.some(bookingValues?.slot, (slot) => _.isEqual(slot.value, time.value)) ? "active" : ""}`} style={{ height: "30px", backgroundColor: time?.disable && (time?.show_enabled === undefined) && "#dbdbdb", textDecoration: time?.disable ? "line-through" : "none" }} onClick={() => { if (!time?.disable) { handleTimeSlotSelection(time) } }}>{time?.label}</div>
                        )) :
                        <div className="text-center text-danger">No slots available for the selected duration!</div>
                    }
                </div>
            </div>
            <div className="mt-2 mb-2">
                <div className="mb-1 fw-bold">
                    <div>Booking Title*</div>
                </div>
                <div>
                    <input type="text" className="w100 input-dd" style={{ resize: "none" }} value={bookingValues?.reason} onChange={(e) => setBookingValues((prev) => ({ ...prev, reason: e.target.value }))} />
                </div>
            </div>
            <div className="mt-2 mb-2">
                <div className="mb-1 fw-bold">
                    <div>Users</div>
                </div>
                <div>
                    <MultiSelect className="input-dd" options={options?.users} optionLabel="user_display_name" value={bookingValues?.users} onChange={(e) => setBookingValues((prev) => ({ ...prev, users: e.target.value }))} filter filterInputAutoFocus panelHeaderTemplate={(options) => PanelHeaderTemplate(options, "users", bookingValues?.users, () => setBookingValues((prev) => ({ ...prev, users: [] })))} />
                </div>
            </div>
            <div className={showCancelBooking ? "d-flex gap-2 justify-content-evenly" : ""}>
                {loader?.save ?
                    <button className="button btn-primary w100 rounded">
                        <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                            <span className="sr-only"></span>
                        </div>
                    </button> :
                    <button className="w100 rounded button btn-primary" onClick={handleSaveBooking}>Save Booking</button>
                }
                {showCancelBooking && (loader?.cancel ?
                    <button className="button btn-default w100 rounded">
                        <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                            <span className="sr-only"></span>
                        </div>
                    </button> :
                    <button className="w100 rounded button btn-default" onClick={() => setShowConfirmation(true)}>Cancel Booking</button>
                )}
            </div>
            <CommanDialog visible={showConfirmation} handleClose={() => setShowConfirmation(false)} handleFun={handleDeleteBooking} message="Are you sure you want to delete this booking?" />
        </div>
    )
}

export default CabinBookingForm